module.exports = __webpack_public_path__ + "static/img/home.ca16115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/home.jpg
// module id = ezDZ
// module chunks = 0